<template>
  <ul class="bj-contact">
    <li
      v-for="(item, index) in contactData"
      :key="index"
      class="box"
      @mouseover="mouseOver(item)"
      @mouseleave="mouseLeave(item)"
    >
      <BjKeyImage :url="item.url" style="width: 24px" />
      <p>{{ item.text }}</p>
      <BjKeyImage v-if="index === 0" class="content wx" :url="$getPublicImage('wx.png')" />
      <div v-if="index === 1" class="content phone">139 39145 487</div>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    const contactWxPNG = this.$getPublicImage('contact-wx.png');
    const contactPhonePNG = this.$getPublicImage('contact-phone.png');
    return {
      contactData: [
        {
          url: contactWxPNG,
          name: 'wx',
          text: '微信',
        },
        {
          url: contactPhonePNG,
          name: 'phone',
          text: '电话热线',
        },
      ],
    };
  },
  methods: {
    // 移入
    mouseOver(item) {
      item.url = this.$getPublicImage(`contact-${item.name}-white.png`);
    },
    // 移出
    mouseLeave(item) {
      item.url = this.$getPublicImage(`contact-${item.name}.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
.bj-contact {
  position: fixed;
  left: 0;
  top: 70%;
  z-index: 2002;
  list-style: none;
  background-color: white;
  margin: 0;
  padding: 0;
  box-shadow: 0 4px 10px 0 rgba(225, 225, 225, 0.5);
  .box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border-radius: 0;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      background-color: $main-dark;
    }
    &:hover p {
      color: white;
    }
    p {
      margin: 0;
      font-size: 12px;
      margin-top: 6px;
      color: $main-dark;
    }
    .content {
      position: absolute;
      z-index: 9;
      left: 60px;
      width: 0;
    }
    .wx {
      height: 90px;
    }
    .phone {
      background-color: $main-dark;
      height: 60px;
      color: white;
      text-align: center;
      overflow: hidden;
      line-height: 60px;
      transition: all 0.2s;
    }
    &:hover .wx {
      width: 90px;
      background: none;
    }
    &:hover .phone {
      width: 150px;
    }
  }
}
</style>
